<template>
  <div>
    <div class="content-head">
      <div>
        <h2>"人努力-天帮忙"指数地图</h2>
      </div>

      <div style="text-align: left">
        <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              <span style="color: #f56c6c"
                >什么是"人努力-天帮忙"指数？<i
                  class="header-icon el-icon-info"
                ></i
              ></span>
            </template>
            <div>
              结合原始污染物浓度与气象调整后的污染物浓度，分解气象和人为因素的影响，计算“人努力—天帮忙”指数
              <br />
              用该年原始浓度与调整后浓度差值相对上一年原始浓度的比率衡量该年气象影响（“天是否帮忙”），
              <span style="color: #f56c6c">正值</span
              >表示气象条件不利，即“天不帮忙”，
              <span style="color: #409eff">负值</span
              >表示气象条件有利，即“天帮忙”；
              <br />
              用连续两年调整后浓度差值相对上一年原始浓度的比率衡量排放水平变化（“人是否努力”），
              <span style="color: #f56c6c">正值</span
              >代表背景浓度上升，即“人不努力”，
              <span style="color: #409eff">负值</span
              >代表背景浓度下降，即“人努力”。
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-form :model="formLabelAlign" class="textAlignLeft">
        <el-form-item label="评估内容" class="marginZero">
          <el-radio-group v-model="assessIndex" @change="pullChange">
            <el-radio label="hindex">人努力指数</el-radio>
            <el-radio label="windex">天帮忙指数</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- <el-form-item label="污染物" class="marginZero">
          <el-radio-group v-model="assessPull" @change="pullChange">
            <el-radio label="PM2.5">PM2.5</el-radio>
            <el-radio label="PM10">PM10</el-radio>
            <el-radio label="SO2">SO2</el-radio>
            <el-radio label="NO2">NO2</el-radio>
            <el-radio label="CO">CO</el-radio>
            <el-radio label="O3">O3</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item label="评估年份">
          <!-- <el-date-picker
            v-model="assessYear"
            type="year"
            placeholder="选择评估年份"
            :picker-options="pickerOptions"
            @change="assessYearChange"
            size="mini"
          ></el-date-picker> -->

          <el-select
            size="mini"
            v-model="assessYear"
            placeholder="请选择"
            @change="assessYearChange"
          >
            <el-option
              v-for="item in Years"
              :key="item"
              :label="item + '年'"
              :value="item"
            ></el-option>
          </el-select>

          <el-select
            size="mini"
            v-model="assessSeason"
            placeholder="请选择"
            @change="assessSeasonChange"
          >
            <el-option
              v-for="item in Seasons"
              :key="item.name"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <!-- 图像下载 -->
    <div>
      <el-row type="flex" justify="end">
        <el-button
          type="success"
          icon="el-icon-download"
          @click="downloadImage"
          :loading="imageDownloading"
          >图像下载</el-button
        >
      </el-row>
    </div>

    <div class="content-body" id="area-hw-index-canvas">
      <el-row>
        <el-col :sm="24" :md="14" :lg="14">
          <div
            class="area-hw-index"
            id="area-hwindex-chart"
            :style="{ height: eleheight + 'px', paddingRight: '1px' }"
          ></div>
        </el-col>
        <el-col :sm="24" :md="10" :lg="10">
          <div
            id="area-hwindex-chart-map"
            :style="{ height: eleheight + 'px' }"
          ></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style scoped>
/* .el-button {
  border-width: 0px;
  color: black;
  padding: 0 10px;
  margin: 0;
  background: transparent;
} */

.el-row {
  margin-bottom: 15px;
}
.el-divider {
  margin: 0;
  /* margin-bottom: 10px; */
}
</style>

<script>
// // @ is an alias to /src
import { debounce } from "@/assets/js/my-utils.js";
import {
  initBaiduMapCharts,
  drawBaiduMapCityBoundary,
  addCityMarker2BaiduMap,
  getRGBColor,
  GenerateMapImgFromDom,
} from "@/assets/js/utils-map.js";
export default {
  name: "Platform",
  data() {
    return {
      cityname: [],
      chart: [],
      map: "",
      disProvince: "",
      pulldata: [],
      eleheight: 520,
      assessYear: "2023",
      assessSeason: 4,
      assessIndex: "hindex",
      assessPull: "PM2.5",
      Years: [
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
      ],

      Seasons: [
        {
          name: "春季",
          value: 1,
        },
        {
          name: "夏季",
          value: 2,
        },
        {
          name: "秋季",
          value: 3,
        },
        {
          name: "冬季",
          value: 4,
        },
        {
          name: "年均",
          value: 0,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > 2020 || time.getFullYear() < 2013;
        },
      },
      chart_data: [],
      mapcenter: [113, 34.5],
    };
  },
  computed: {},
  methods: {
    downloadImage() {
      let imageDom = document.getElementById("area-hw-index-canvas");

      let pull = this.assessPull;
      let seasonZh = ["全年平均", "春季", "夏季", "秋季", "冬季"];

      if(seasonZh[this.assessSeason]){
        let time = this.assessYear + "年" + seasonZh[this.assessSeason];
      }else{
        let time = this.assessYear + "年全年平均"; 
      }
      
      let visualMapText = ["人不努力", "人努力"];
      let ass_Type = "人努力指数";
      if (pull != "hindex") {
        ass_Type = "天帮忙指数";
        visualMapText = ["天不帮忙", "天帮忙"];
      }

      let title = time + ass_Type + "及排名变化";

      GenerateMapImgFromDom(imageDom, title + ".png");
    },

    assessYearChange() {
      this.chart_data = [];
      // this.assessYear = this.assessYear.getFullYear() + "";
      this.updateCharts();
    },
    assessSeasonChange() {
      this.chart_data = [];
      this.updateCharts();
    },
    pullChange() {
      this.chart_data = [];
      this.updateCharts();
    },

    getHWindexData() {
      const that = this;
      if (this.chart_data.length <= 0) {

        let url = "/AQAssess/getAreaHWindex/" + this.assessPull + "/" + this.assessYear + "/" + this.assessSeason + "/" + this.assessIndex;
        this.$axios
          .get(url)
          // .post("/AQAssess/getData.php", {
          //   database: "area_hwindex",
          //   index_type: this.assessPull,
          //   year: this.assessYear,
          //   season: this.assessSeason,
          // })
          .then((res) => {
            // console.log(res.data);
            if (res.data.length < 1) {
              this.$message({
                type: "info",
                message: "当前季度没有数据",
              });
            } else {
              that.chart_data = res.data;

              let pulldata = [];
              that.chart_data.forEach((element) => {
                for (let i = 0; i < that.assesscity.length; i++) {
                  if (element[0] == that.assesscity[i][1]) {
                    pulldata.push(element);
                    break;
                  }
                }
              });

              // console.log(that.pulldata);
              let seasonZh = ["全年", "春", "夏", "秋", "冬"];
              that.drawAreaHWRankChart(
                that.chart[0],
                pulldata,
                that.assessYear + seasonZh[that.assessSeason],
                that.assessIndex
              );

              that.drawAreaMapOverlays(pulldata, that.assessIndex);

              that.pulldata = pulldata;
            }
          });
      } else {
        let pulldata = [];
        this.chart_data.forEach((element) => {
          for (let i = 0; i < that.assesscity.length; i++) {
            if (element[0] == that.assesscity[i][1]) {
              pulldata.push(element);
              break;
            }
          }
        });

        // console.log(this.chart_data);

        // console.log(that.pulldata);
        let seasonZh = ["全年", "春", "夏", "秋", "冬"];
        this.drawAreaHWRankChart(
          this.chart[0],
          pulldata,
          this.assessYear + seasonZh[that.assessSeason],
          this.assessIndex
        );

        this.drawAreaMapOverlays(pulldata, this.assessIndex);

        this.pulldata = pulldata;
      }
    },
    drawAreaMapOverlays(pulldata, pull) {
      // 1. 创建城市和颜色对应表

      let aCity = [];
      let aColor = [];

      pulldata.forEach((item, idx) => {
        let city = item[0];

        let city_color;
        if (city) {
          aCity.push(city + "市");
          city_color = getRGBColor(parseFloat(item[1]), "hw-index", pull);
          aColor.push(city_color);
        }
      });

      // 2.绘制
      // dep = 1 表示市级
      let depth = 1;

      var that = this;
      // 清理图层

      if (this.disProvince) {
        this.map.remove(this.disProvince);
      }

      this.disProvince && this.disProvince.setMap(null);

      this.disProvince = new AMap.DistrictLayer.Province({
        zIndex: 12,

        adcode: [
          110000, // 北京
          120000, // 天津市
          130000, // 河北省
          140000, // 山西省
          150000, // 内蒙古自治区
          310000, // 上海市
          320000, // 江苏省
          340000, // 安徽省
          360000, // 江西省
          370000, // 山东省
          410000, // 河南省
          610000, // 陕西省
          330000, // 浙江
        ],

        depth: depth,
        opacity: 0.9,
        styles: {
          fill: function (properties) {
            // properties为可用于做样式映射的字段，包含
            // NAME_CHN:中文名称
            // adcode_pro
            // adcode_cit
            // adcode
            let adcode_pro = properties.adcode_pro;

            let NAME_CHN = properties.NAME_CHN;

            let colorIDX = aCity.indexOf(NAME_CHN);
            if (colorIDX != -1) {
              return aColor[colorIDX];
            }

            return "";
          },
          "province-stroke": "cornflowerblue",
          "city-stroke": "white", // 中国地级市边界
          "county-stroke": "rgba(255,255,255,0.5)", // 中国区县边界
        },
      });

      this.disProvince.setMap(this.map);
    },

    drawAreaHWRankChart(chart, data, time, pull) {
      let rank_data = [];
      let value_data = [];
      data.forEach((item, idx) => {
        rank_data.push([item[0], item[2]]);
        value_data.push([item[0], (100 * item[1]).toFixed(1)]);
      });

      let visualMapTop = 20;

      let visualMapText = ["人不努力", "人努力"];
      let ass_Type = "人努力指数";
      if (pull != "hindex") {
        ass_Type = "天帮忙指数";
        visualMapText = ["天不帮忙", "天帮忙"];
      }

      let title = time + ass_Type + "及排名变化";

      let option = {
        title: {
          text: title,
          // subtext: "数据来自西安兰特水电测控技术有限公司",
          left: "center",
          align: "right",
        },
        grid: {
          bottom: 40,
          left: 20,
          right: 40,
          containLabel: true,
        },

        toolbox: {
          feature: {
            // restore: {},
            // saveAsImage: {},
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            animation: false,
            label: {
              backgroundColor: "#505765",
            },
          },
          formatter: function (params) {
            let text = params[0].axisValue + "<br>";
            params.forEach((element) => {
              if (element.seriesType == "bar") {
                text +=
                  element.marker +
                  ass_Type +
                  ": " +
                  element.value[1] +
                  "% <br>";
              } else {
                text +=
                  element.marker +
                  ass_Type +
                  "排名: " +
                  element.value[1] +
                  "<br>";
              }
            });
            return text;
          },
        },
        legend: {
          left: 10,
        },
        visualMap: [
          {
            show: true,
            seriesIndex: 0,
            type: "piecewise",
            dimension: 1,
            min: -visualMapTop,
            max: visualMapTop,
            text: visualMapText,
            top: 0,
            right: 10,
            orient: "horizontal",
            inRange: {
              color: ["#1E90FF", "#FF0000"],
            },
            pieces: [
              { min: 0 }, // 不指定 max，表示 max 为无限大（Infinity）。
              { max: 0 }, // 不指定 min，表示 min 为无限大（-Infinity）。
            ],
          },
        ],
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            right: 55,
            startValue: 0,
            endValue: 20,
          },
        ],
        xAxis: [
          {
            type: "category",
            axisLine: { onZero: false },
          },
        ],
        yAxis: [
          {
            name: ass_Type + "/%",
            type: "value",
            inverse: true,
            nameLocation: "start",
          },
          {
            name: "排名",
            type: "value",
          },
        ],
        series: [
          {
            name: ass_Type,
            type: "bar",
            areaStyle: {},
            lineStyle: {
              width: 1,
            },
            label: {
              show: true,
              formatter: function (data) {
                // console.log(data);
                return data.data[1] + "%";
              },
              color: "#F56C6C",
              position: "top",
            },
            data: value_data,
          },
          {
            name: "排名曲线",
            type: "line",
            yAxisIndex: 1,
            // areaStyle: {},
            lineStyle: {
              width: 1,
            },
            data: rank_data,
          },
        ],
      };

      chart.setOption(option, {
        notMerge: true,
      });
      chart.resize();
      chart.hideLoading();
    },

    updateCharts() {
      this.chart.forEach((element) => {
        element.showLoading();
      });

      this.getHWindexData();
    },
  },
  created() {},
  mounted() {
    if (this.show) {
      this.chart.push(
        this.$echarts.init(document.getElementById("area-hwindex-chart"))
      );

      this.map = new AMap.Map("area-pull-map", {
        zoom: 5,
        center: [113, 34.5],
        pitch: 0,
        viewMode: "3D",
      });

      this.updateCharts();
    }

    const that = this;
    window.addEventListener("resize", () => {
      that.chart.forEach((element) => {
        element.resize();
      });
    });
  },
  watch: {
    assesscity: function (newAssesscity, oldAssesscity) {
      this.assesscity = newAssesscity;

      if (this.show) {
        this.updateCharts();
      }
    },

    show: function (newShow, oldShow) {
      this.show = newShow;
      if (this.show) {
        this.chart.forEach((element) => {
          element.dispose();
        });
        this.chart = [];

        this.chart.push(
          this.$echarts.init(document.getElementById("area-hwindex-chart"))
        );

        this.map = new AMap.Map("area-hwindex-chart-map", {
          zoom: 5,
          center: [113, 34.5],
          pitch: 0,
          viewMode: "3D",
          WebGLParams: {
            preserveDrawingBuffer: true,
          },
        });

        this.updateCharts();
      } else {
        this.chart.forEach((element) => {
          element.clear();
        });
      }
    },
  },
  props: {
    assesscity: {
      type: Array,
      // 对象或数组默认值必须从一个工厂函数获取
      default: function () {
        return [
          ["直辖市", "北京"],
          ["直辖市", "天津"],
        ];
      },
    },

    show: {
      type: Boolean,
      default: false,
    },
  },
};
</script>



